// extracted by mini-css-extract-plugin
export default {"zoomModal":"h3-z","image":"i3-z","button":"j3-z","isOverlayShown":"k3-z"};